import { render, staticRenderFns } from "./topiccategory-add-or-update.vue?vue&type=template&id=4f2010a4&"
import script from "./topiccategory-add-or-update.vue?vue&type=script&lang=js&"
export * from "./topiccategory-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports